// extracted by mini-css-extract-plugin
export default {"root":"CandidateCheckValues_root__2a0LX","key":"CandidateCheckValues_key__O3kQa","displayBox":"CandidateCheckValues_displayBox__e-xjK"};